/* Extracted from snippets/cro-delivery-promise.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function() {
    try {
      const container = document.querySelector('[data-delivery-countdown]');
      if (!container) return;

      const textEl = container.querySelector('[data-countdown-text]');
      const locale = container.getAttribute('data-locale') || 'en';
      let activeTimeText = container.getAttribute('data-active-time') || '1-2';

      /* ── Translation strings from Shopify locale files ── */
      const T = {
        orderWithin: container.getAttribute('data-t-order-within') || 'Order within',
        andReceive:  container.getAttribute('data-t-and-receive')  || 'to receive it',
        orderNow:    container.getAttribute('data-t-order-now')    || 'Order now to receive your package',
        tomorrow:    container.getAttribute('data-t-tomorrow')     || 'tomorrow',
        dispatchToday: container.getAttribute('data-t-dispatch-today') || 'Order within __TIME__ for dispatch today',
        dispatchNext:  container.getAttribute('data-t-dispatch-next')  || 'Dispatched the next working day'
      };

      /* ── Cut-off hour comes from the Levering settings, not a literal ── */
      const cutoffHour = parseInt(container.getAttribute('data-cutoff-hour'), 10) || 14;

      /* ── Parse holidays from comma-separated YYYY-MM-DD ── */
      const holidayStr = container.getAttribute('data-holidays') || '';
      const holidays = new Set(
        holidayStr.split(',')
          .map(function(s) { return s.trim(); })
          .filter(function(s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); })
      );

      /* ── Parse transit min/max business days ── */
      const matches = activeTimeText.match(/\d+/g);
      let minDays = 1;
      let maxDays = 2;
      if (matches) {
        if (matches.length === 1) {
          minDays = parseInt(matches[0]);
          maxDays = minDays;
        } else if (matches.length >= 2) {
          minDays = parseInt(matches[0]);
          maxDays = parseInt(matches[1]);
        }
      }

      /* ── Helpers ── */
      function toISODate(date) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, '0');
        var d = String(date.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + d;
      }

      function isBusinessDay(date) {
        var dow = date.getDay();
        if (dow === 0 || dow === 6) return false; /* Sun=0, Sat=6 */
        return !holidays.has(toISODate(date));
      }

      function addBusinessDays(startDate, days) {
        var date = new Date(startDate);
        var added = 0;
        while (added < days) {
          date.setDate(date.getDate() + 1);
          if (isBusinessDay(date)) {
            added++;
          }
        }
        return date;
      }

      /* ── Format date using Intl for any language ── */
      function formatDate(date) {
        try {
          var opts = { weekday: 'long', month: 'short', day: 'numeric' };
          return new Intl.DateTimeFormat(locale, opts).format(date);
        } catch (e) {
          return date.toLocaleDateString();
        }
      }

      function updateCountdown() {
        /* Copenhagen time calculations — universal 14:00 CET cut-off */
        var options = {
          timeZone: 'Europe/Copenhagen',
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric',
          hour12: false
        };
        var copTimeStr;
        try {
          copTimeStr = new Date().toLocaleString('en-US', options);
        } catch (e) {
          copTimeStr = new Date().toLocaleString('en-US');
        }

        var parts = copTimeStr.match(/(\d+)\/(\d+)\/(\d+),\s+(\d+):(\d+):(\d+)/);
        if (!parts) return;

        var year   = parseInt(parts[3]);
        var month  = parseInt(parts[1]) - 1;
        var day    = parseInt(parts[2]);
        var hour   = parseInt(parts[4]);
        var minute = parseInt(parts[5]);

        var copDate = new Date(year, month, day, hour, minute, 0);
        var todayStr = toISODate(copDate);

        var shipDate = new Date(copDate);
        var isToday = false;

        /* Check: Is today Mon-Fri, before the cut-off, AND not a holiday? */
        var dayOfWeek = copDate.getDay();
        if (dayOfWeek >= 1 && dayOfWeek <= 5 && hour < cutoffHour && !holidays.has(todayStr)) {
          isToday = true;
        } else {
          /* Advance to next business day (skip weekends + holidays) */
          do {
            shipDate.setDate(shipDate.getDate() + 1);
          } while (!isBusinessDay(shipDate));
        }

        var deliveryMinDate = addBusinessDays(shipDate, minDays);
        var deliveryMaxDate = addBusinessDays(shipDate, maxDays);

        var dateRangeText = '';
        if (minDays === maxDays) {
          dateRangeText = formatDate(deliveryMinDate);
        } else {
          dateRangeText = formatDate(deliveryMinDate) + ' – ' + formatDate(deliveryMaxDate);
        }

        /* The dispatch line above the add-to-cart button shares this clock and
           this cut-off. Two independent countdowns would eventually disagree. */
        function setDispatch(text) {
          var el = document.querySelector('[data-dispatch-cutoff]');
          if (!el) return;
          el.innerHTML = text;
          el.hidden = false;
        }

        if (isToday) {
          var cutOffTime = new Date(year, month, day, cutoffHour, 0, 0);
          var diffMs = cutOffTime - copDate;
          if (diffMs > 0) {
            var totalMinutes = Math.floor(diffMs / 1000 / 60);
            var hoursLeft = Math.floor(totalMinutes / 60);
            var minutesLeft = totalMinutes % 60;

            var timeStr = hoursLeft + 'h ' + minutesLeft + 'm';
            var tomorrowHint = (minDays === 1 && maxDays === 1) ? ' ' + T.tomorrow + ' ' : ' ';

            textEl.innerHTML = T.orderWithin + ' <strong>' + timeStr + '</strong> ' + T.andReceive + tomorrowHint + '<strong>' + dateRangeText + '</strong>';
            setDispatch(T.dispatchToday.replace('__TIME__', '<strong>' + timeStr + '</strong>'));
            return;
          }
        }

        /* Default: after cut-off, weekend, or holiday */
        textEl.innerHTML = T.orderNow + ' <strong>' + dateRangeText + '</strong>';
        setDispatch(T.dispatchNext);
      }

      /* ── Listen for variant-change active-time updates ── */
      window.addEventListener('cro-active-time-changed', function(e) {
        if (e.detail && e.detail.time) {
          container.setAttribute('data-active-time', e.detail.time);
          activeTimeText = e.detail.time;
          var newMatches = e.detail.time.match(/\d+/g);
          if (newMatches) {
            if (newMatches.length === 1) {
              minDays = parseInt(newMatches[0]);
              maxDays = minDays;
            } else if (newMatches.length >= 2) {
              minDays = parseInt(newMatches[0]);
              maxDays = parseInt(newMatches[1]);
            }
          }
          updateCountdown();
        }
      });

      updateCountdown();
      setInterval(updateCountdown, 30000);
    } catch(e) {
      console.error('cro-delivery-promise error:', e);
    }
  })();
